import { ApiError } from './api';

// Local accounts (WRMM-134): a password as the first factor, and emailed setup and reset links. Plain fetches, as for the
// second factor: a refusal here is a sign-in failure, not a session ending. The server keeps the pending sign-in in an
// HttpOnly cookie.
async function post<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(path, { method: 'POST', credentials: 'same-origin', cache: 'no-store', redirect: 'error',
    headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
  if (!response.ok) throw new ApiError(response.status);
  return (response.status === 204 ? undefined : await response.json()) as T;
}

/** Which sign-ins this server offers. Anything unexpected reads as Google only. */
export async function getSignInOptions(signal?: AbortSignal): Promise<{ provider: 'google' | 'synthetic'; localAccounts: boolean }> {
  try {
    const response = await fetch('/auth/provider', { credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal });
    const body = response.ok ? await response.json() as { provider?: unknown; localAccounts?: unknown } : {};
    return { provider: body.provider === 'synthetic' ? 'synthetic' : 'google', localAccounts: body.localAccounts === true };
  } catch { return { provider: 'google', localAccounts: false }; }
}

export const signInWithPassword = (email: string, password: string) => post<void>('/auth/password', { email, password });
export const forgotPassword = (email: string) => post<void>('/auth/password/forgot', { email });
export interface AccountLink { purpose: 'setup' | 'reset'; email: string; name: string | null }
export const readLink = (token: string) => post<AccountLink>('/auth/link', { token });
export const setPasswordFromLink = (token: string, password: string) => post<void>('/auth/link/password', { token, password });
